export const USER = {
  LOGIN: 'USER_LOGIN',
  LOGIN_DONE: 'USER_LOGIN_DONE',
  LOGIN_FAILED: 'USER_LOGIN_FAILED',
  LOGOUT: 'USER_LOGOUT',
  LOGOUT_DONE: 'USER_LOGOUT_DONE',
  LOGOUT_FAILED: 'USER_LOGOUT_FAILED',
  RESET_PASSWORD: 'USER_RESET_PASSWORD',
  NOT_AUTHORIZED: 'USER_NOT_AUTHORIZED',
  GET: 'USER_GET_ME',
  GET_DONE: 'USER_GET_ME_DONE',
  GET_FAILED: 'USER_GET_ME_FAILED',
  UPDATE: 'USER_UPDATE_ME',
  UPDATE_DONE: 'USER_UPDATE_ME_DONE',
  UPDATE_FAILED: 'USER_UPDATE_ME_FAILED',
  ADD: 'USER_ADD',
  ADD_DONE: 'USER_ADD_DONE',
  ADD_FAILED: 'USER_ADD_FAILED',
  UPLOAD: 'USER_UPLOAD',
  UPLOAD_DONE: 'USER_UPLOAD_DONE',
  REMOVE_UPLOADED: 'USER_REMOVE_UPLOADED',
  REMOVE_UPLOADED_DONE: 'USER_REMOVE_UPLOADED_DONE',
  REMOVE_UPLOADED_FAILED: 'USER_REMOVE_UPLOADED_FAILED',
  GET_SETTINGS: 'USER_GET_SETTINGS',
  GET_SETTINGS_DONE: 'USER_GET_SETTINGS_DONE',
  GET_SETTINGS_FAILED: 'USER_GET_SETTINGS_FAILED',
  UPDATE_SETTINGS: 'USER_UPDATE_SETTINGS',
  UPDATE_SETTINGS_DONE: 'USER_UPDATE_SETTINGS_DONE',
  UPDATE_SETTINGS_FAILED: 'USER_UPDATE_SETTINGS_FAILED',
};

export const login = (email, password) => ({ type: USER.LOGIN, email, password });
export const logout = () => ({ type: USER.LOGOUT });
export const resetPassword = email => ({ type: USER.RESET_PASSWORD, email });
export const register = fields => ({ type: USER.ADD, fields });
export const get = () => ({ type: USER.GET });
export const update = fields => ({ type: USER.UPDATE, fields });
export const setError = message => ({ type: USER.LOGIN_FAILED, message });
export const setProfileError = message => ({ type: USER.UPDATE_FAILED, message });
export const uploadUserImage = (file, id) => ({ type: USER.UPLOAD, file, id });
export const removeUserImage = (storageId, userId) => ({
  type: USER.REMOVE_UPLOADED, storageId, userId,
});
export const getSettings = () => ({ type: USER.GET_SETTINGS });
export const updateSettings = fields => ({ type: USER.UPDATE_SETTINGS, fields });



// WEBPACK FOOTER //
// ./src/actions/user.js